import { defineMessages } from 'react-intl';

export const homeScreenMobileHeaderMessages = defineMessages({
  navigateToAccountScreenBtnLabel: {
    defaultMessage: 'Navigate to the Account Screen',
    description: 'Home screen | Navigate to Account screen button label',
  },
});
